exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-template-editor .editor-content{padding:.375rem;border:1px solid #efefef;font-size:.875rem}.fts-template-editor .editor-expression{padding:.375rem;font-size:.675rem;color:#707070;background:#efefef}.template-editor fts-i-expression{background-color:#f7ffc8;padding:3px;margin:2px}.template-editor fts-i-unit{background-color:#c8f0ff;padding:1px;margin:2px}.information-unit-select{margin:3px}.template-editor{line-height:1.5;white-space:pre-wrap}.template-editor:empty:before{content:attr(placeholder);-webkit-text-fill-color:#9e9e9e}", ""]);

// exports
